import React from 'react';

import Box from 'components/elements/Box';
import H1 from 'components/elements/h1';

import { ReactComponent as DSPCharts } from 'icons/dsp-charts-icon.svg';
import { ReactComponent as OfficialCharts } from 'icons/official-charts-button-icon.svg';

import { ChartTypes } from 'types/shared';
import { DSPChartToolbarIcon, OfficialChartIcon } from '../styles';

interface IChartsTabsHeaderProps {
  isLargeScreen: boolean;
  chartPage: ChartTypes;
  title: string;
}

const ChartsTabsHeader: React.FC<IChartsTabsHeaderProps> = (props) => {
  const { isLargeScreen, chartPage, title } = props;
  return (
    <Box display="flex">
      {!isLargeScreen && (
        <DSPChartToolbarIcon>
          {chartPage === 'dsp' ? (
            <DSPCharts />
          ) : (
            <OfficialChartIcon>
              <OfficialCharts />
            </OfficialChartIcon>
          )}
        </DSPChartToolbarIcon>
      )}
      <H1 fontSize={4} my={0} marginBottom={5}>
        {title}
      </H1>
    </Box>
  );
};

export default ChartsTabsHeader;
